"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPromiseV2 = fetchPromiseV2;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function fetchPromiseV2(_x, _x2) {
  return _fetchPromiseV.apply(this, arguments);
}
function _fetchPromiseV() {
  _fetchPromiseV = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(storeId, skuDetailList) {
    var postalCode, payload, sessionId, headers, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          postalCode = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.PINCODE);
          payload = _objectSpread({
            skuDetailList: skuDetailList,
            ecp: _constants.ECP,
            ecpShopId: storeId
          }, postalCode && {
            postalCode: postalCode
          });
          sessionId = (0, _utils.getBwaMutantSessionId)();
          headers = _objectSpread({
            "Content-Type": "application/json"
          }, sessionId && (0, _defineProperty2["default"])({}, _constants.BWA_SESSION_HEADER, sessionId));
          _context.prev = 4;
          _context.next = 7;
          return fetch(_constants.API_ENDPOINTS.fetchPromiseV2(storeId), {
            method: "POST",
            headers: headers,
            body: JSON.stringify(payload)
          });
        case 7:
          response = _context.sent;
          _context.next = 10;
          return response.json();
        case 10:
          return _context.abrupt("return", _context.sent);
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](4);
          console.error("Error Fetching Promise V2:", _context.t0);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 13]]);
  }));
  return _fetchPromiseV.apply(this, arguments);
}
//# sourceMappingURL=fetch-promise.js.map
